import NotificationRepository from '@/api/repositories/NotificationRepository';
import { ChatsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';

let intervalId;

export default {
	state: {
		notifications: [],
		notificationsCount: null,
		chatsCount: null,
		isChatExpanded: false,
		unfinishedChatMessages: [],
		showHelpModal: false,
	},
	getters: {
		getUnreadNotifications(state) {
			return state.notifications.filter(notification => !notification.isRead);
		},
		getUnreadNotificationCount(state) {
			return state.notificationsCount;
		},
		getNotifications(state) {
			return state.notifications;
		},
		getUnreadChatsCount(state) {
			return state.chatsCount;
		},
		getIsChatExpanded(state) {
			return state.isChatExpanded;
		},
		getUnfinishedChatMessage: state => chatID => {
			return state.unfinishedChatMessages.find(element => element.id === chatID);
		},
		getIsShowHelpModal(state) {
			return state.showHelpModal;
		},
	},
	mutations: {
		clearNotifications(state) {
			state.notifications = [];
		},
		addNotification(state, payload) {
			state.notifications.push(payload);
		},
		setNotification(state, payload) {
			state.notifications = payload;
		},
		setNotificationsCount(state, payload) {
			state.notificationsCount = payload;
		},
		setChatsCount(state, payload) {
			state.chatsCount = payload;
		},
		setIsChatExpanded(state, payload) {
			state.isChatExpanded = payload;
		},
		setUnfinishedChatMessage(state, payload) {
			const messageIndex = state.unfinishedChatMessages.findIndex(element => element.id === payload.id);
			if (messageIndex === -1) {
				state.unfinishedChatMessages.push(payload);
			} else {
				state.unfinishedChatMessages[messageIndex] = payload;
			}
		},
		clearAllUnfinishedMessages(state) {
			state.unfinishedChatMessages = [];
		},
		clearUnfinishedMessage(state, payload) {
			const messageIndex = state.unfinishedChatMessages.findIndex(element => element.id === payload.id);
			state.unfinishedChatMessages.splice(messageIndex, 1);
		},
		setIsShowHelpModal(state, payload) {
			state.showHelpModal = payload;
		},
	},
	actions: {
		updateNotifications({ commit, dispatch }, payload) {
			return NotificationRepository.index({ page: payload == null ? 1 : payload.page, paginate: 25 })
				.then(response => {
					if (response.data?.data) {
						if (payload !== null && payload !== undefined && payload.page !== 1) {
							response.data.data.forEach(element => {
								commit('addNotification', element);
							});
						} else {
							commit('setNotification', response.data.data);
						}
						dispatch('updateNotificationCount');

						return { currentPage: response.data.meta.current_page, lastPage: response.data.meta.last_page };
					}
				})
				.catch(error => console.log(error));
		},
		updateNotificationCount({ commit }) {
			NotificationRepository.getCount().then(response => {
				commit('setNotificationsCount', response.data);
			});
		},
		updateChatsCount({ commit }) {
			ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.unreadNotificationCountGet()
				.then(response => {
					commit('setChatsCount', 0);
					commit('setChatsCount', response.data);
				});
		},
		loopUpdateNotifications({ commit, dispatch }) {
			dispatch('updateNotificationCount');
			dispatch('updateChatsCount');
			dispatch('fetchMe');
			if (intervalId) {
				clearInterval(intervalId);
			}
			intervalId = setInterval(() => {
				dispatch('updateNotificationCount');
				dispatch('updateChatsCount');
				dispatch('fetchMe');
			}, 60000);
		},
		resetNotifications({ commit }) {
			commit('setNotification', []);
		},
		stopLoopUpdateNotifications({ commit, dispatch }) {
			clearInterval(intervalId);
		},
	},
};
